import { CxEvent } from '@spartacus/core';

export class Ga4GgUserRegistrationSuccessEvent extends CxEvent {
  event?: string;
}
